import { Component } from '@angular/core';

@Component({
  selector: 'epl-no-frame',
  templateUrl: './no-frame.component.html',
  styleUrls: ['./no-frame.component.scss']
})
export class NoFrameComponent {

}
